import { combineReducers } from 'redux';
import roulette from './rouletteReducer';
import rewards from './rewardsReducer';

const rootReducer = combineReducers({
  roulette,
  rewards
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/